/**
 * アクセストークン
 */
export function isTokenExists(): boolean {
  return getToken() ? true : false
}

export function getToken(): string | null {
  return localStorage.getItem('token')
}

export function setToken(value: string): void {
  localStorage.setItem('token', value)
}

export function removeToken(): void {
  localStorage.removeItem('token')
}

export const isExistLineState = (): boolean => (getLineState() ? true : false)

export const getLineState = (): string | null => localStorage.getItem('lineState')

export const setLineState = (value: string): void => localStorage.setItem('lineState', value)

export const removeLineState = (): void => localStorage.removeItem('lineState')
